// Central site configuration: assets + external links
export const AMAZON_LINK = "https://a.co/d/051oqb2E";

export const SHARE_TEXT =
  "\"Democracy is a Monarchy in Disguise.\" — Election on Mars. Read it.";

export const PDFS = {
  prologue: {
    label: "Prologue",
    filename: "Election-on-Mars-Prologue.pdf",
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_citizen-manifesto-1/artifacts/9p1rh1fx_Prologue.pdf",
  },
  sampleChapters: {
    label: "Chapters 1 – 6 (Sample)",
    filename: "Election-on-Mars-Chapters-1-6.pdf",
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_citizen-manifesto-1/artifacts/50zvktxz_Sample%201-6.pdf",
  },
};

export const ASSETS = {
  cover:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_citizen-manifesto-1/artifacts/qw8eiusm_ELECTION%20ON%20MARS_%20BOOK%20COVER_AYUSH%20GARODIA.jpg",
  sketch:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_citizen-manifesto-1/artifacts/je53gj1f_8d2c540fbbb8e0e8c4ee12fd64e424ee.webp",
};
